import { render, staticRenderFns } from "./BaiMi.vue?vue&type=template&id=e7edda3c&scoped=true&"
import script from "./BaiMi.vue?vue&type=script&lang=js&"
export * from "./BaiMi.vue?vue&type=script&lang=js&"
import style0 from "./BaiMi.vue?vue&type=style&index=0&id=e7edda3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7edda3c",
  null
  
)

export default component.exports